import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button from "./Button";
import Moment from "./Moment";
import DropdownButton from "./DropdownButton";
import Icon from "./Icon";
import styles from "./EmailListItem.module.css";
import { history } from "../history";

export default class EmailModuleListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onClone = this.onClone.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onClone() {
    const { id } = this.props.emailModule;
    this.props.onClone(id);
  }

  onDelete() {
    const { id } = this.props.emailModule;
    this.props.onDelete(id);
  }

  handleClick() {
    const { id } = this.props.emailModule;
    const { accountId } = this.props;
    history.push(`/clients/${accountId}/email-modules/${id}`);
  }

  render() {
    const { id, name, EmailTemplate, updatedAt, updatedByName } =
      this.props.emailModule;
    const { accountId } = this.props;

    return (
      <tr>
        <td style={{ width: "200px" }} onClick={this.handleClick}>
          <div className={styles.preview}>
            {id && accountId && (
              <img
                src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/email-modules/${id}/image?updatedAt=${updatedAt || Date.now()}`}
              />
            )}
          </div>
        </td>
        <td onClick={this.handleClick}>{name}</td>
        <td onClick={this.handleClick}>
          {EmailTemplate && EmailTemplate.name}
        </td>
        <td style={{ width: "150px" }} onClick={this.handleClick}>
          {updatedByName}
        </td>
        <td style={{ width: "180px" }} onClick={this.handleClick}>
          <Moment date={updatedAt} />
        </td>
        <td style={{ width: "160px", textAlign: "right" }}>
          <Link to={`/clients/${accountId}/email-modules/${id}`}>
            <Button type="link" title="Edit">
              <Icon icon="pencil" />
            </Button>
          </Link>
          <DropdownButton
            type="link"
            pin="right"
            options={[
              {
                label: "Clone",
                onClick: this.onClone,
              },
              {
                type: "divider",
              },
              {
                label: "Delete",
                onClick: this.onDelete,
              },
            ]}
          />
        </td>
      </tr>
    );
  }
}

EmailModuleListItem.propTypes = {
  accountId: PropTypes.string.isRequired,
  emailModule: PropTypes.object.isRequired,
  onClone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
